import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { getDocTypes } from "@/api/customerCenter/customerCenter";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
import addTypeItem from "./components/addTypeItem.vue"; // import addDocumetItem from "./components/addDocumetItem.vue";

export default {
  name: "documentTypeList",
  components: {
    addTypeItem: addTypeItem
  },
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      searchData: {
        page_size: 10,
        page: 1
      },
      tableData: [],
      total: 0,
      hasMore: false
    };
  },
  created: function created() {
    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    getServer: function getServer() {
      var _this = this;

      this.paramsData.server_id = '';
      serverList({
        is_prod: this.paramsData.is_prod,
        page_size: ''
      }).then(function (res) {
        if (res.status == 200) {
          _this.serverList = res.data;
        }
      });
    },
    sizeChange: function sizeChange(val) {
      this.searchData.page_size = val;
      this.searchClick(1);
    },
    changePage: function changePage(targetPage) {
      console.log("targetPage==", targetPage);
      this.searchClick(targetPage);
    },
    searchClick: function searchClick(e) {
      var _this2 = this;

      this.tableData = [];
      this.searchData.page = e;
      this.reqLoading = true;

      if (this.paramsData.server_id) {
        this.searchData.server_id = this.paramsData.server_id;
      } else {
        this.searchData.server_id = '';
      }

      console.log("paramsData.server_id", this.paramsData.server_id);
      getDocTypes(_objectSpread({}, this.searchData)).then(function (res) {
        if (res.status == 'ok') {
          _this2.tableData = res.items || [];
          _this2.hasMore = _this2.tableData.length === _this2.searchData.page_size;
        }
      }).finally(function () {
        _this2.reqLoading = false;
      });
    }
  }
};